import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  color?: string;
};

export const Lineups = ({ size = 2, color = 'currentColor' }: Props) => {
  return (
    <svg
      style={{
        width: unitMapping[size],
        height: unitMapping[size],
        color,
      }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2858_5652)">
        <path
          d="M1.43998 13.8742V7.53779L3.83998 8.16415V13.8482H4.79998V6.98973L7.6852 7.77543V13.8482H8.63998V4.80078L15.84 5.64383V13.8482H16.7948V7.67343L19.2 6.98973C19.2 6.98973 19.2 7.83321 19.2 8.37367C19.2 10.5116 19.2 13.8482 19.2 13.8482L20.1716 13.8598V8.20275L22.5335 7.54937V13.9034L24.48 13.8598L12.24 17.7608V17.7453L-1.90735e-05 13.8444L1.43998 13.8742Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2858_5652">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
